import { NotFound } from '@prenuvo/shared-library';
import styled from 'styled-components';

// styles
// ----------------------------------------------------------------------

const Container = styled.div`
  margin: 24px auto;
  width: 100%;
`;

const Wrapper = styled.div`
  min-height: 100%;
`;

// ----------------------------------------------------------------------

const NotFoundPage = () => {
  return (
    <Wrapper>
      <Container>
        <NotFound
          title="401: You do not have access to this page"
          description="You do not have access to this page. If you are a Nurse Practitioner, or should have access to the Nurse Practitioner Dashboard, please request access with the tech team"
        />
      </Container>
    </Wrapper>
  );
};
export default NotFoundPage;
